
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","stroke":"#000"}},[_c('path',{attrs:{"d":"M.5 6.771a1.238 1.238 0 011.236-1.236H16.14c.683 0 1.236.554 1.236 1.236v11.424c0 .683-.554 1.236-1.236 1.237H1.737A1.238 1.238 0 01.5 18.196V6.77zM24.501 7.728v9.548l-4.966-2.711V10.44l4.966-2.712z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h25v25H0z"}})])])])
          )
        }
      }
    